/**
 * Extracts backend validation error codes (e.g. <c>AGREEMENT_IMPORT_CONTRACT_NOT_APPROVABLE</c>)
 * from an RTK Query error, falling back to the raw <c>detail</c> message when the response
 * isn't a <c>DomainValidationException</c>-shaped payload.
 */
export function extractErrorCodes(err: unknown): string[] {
  if (err == null || typeof err !== 'object') return [];
  const data = 'data' in err ? (err as { data?: unknown }).data : undefined;
  if (data == null || typeof data !== 'object') return [];

  const errors = (data as { errors?: Record<string, string[]> }).errors;
  if (errors) {
    const codes = Object.values(errors).flat();
    if (codes.length > 0) return codes;
  }

  const detail = (data as { detail?: string }).detail;
  return detail ? [detail] : [];
}
